import React from "react";
import kn_logo from '../../../assets/kn_logo_white.svg';

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This functions displays the footer of the WebApp
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export function Footer() {
    return (
        <footer>
            <img src={kn_logo} height={50} alt={"logo"} style={{fill:"#FFFFFF"}}/>
        </footer>
    );
}
